<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "MainApp",
};
</script>

<style></style>
